

// import React, { useEffect, useState, useRef } from "react";

// const PRODUCTS_API = "https://server.havbit.in/api/public/products";
// const USERS_API    = "https://server.havbit.in/api/website-user/all";
// const BRANDS_API   = "https://server.havbit.in/api/vendor/brands/public";

// const ORDERS_DELIVERED_API = "https://seller.parcelx.in/shipment?order_status=delivered";

// // ─── Smart count extractor ────────────────────────────────────────────────────
// const extractCount = (data) => {
//   if (!data) return 0;
//   if (typeof data === "number") return data;

//   const candidates = [
//     data?.total,
//     data?.totalCount,
//     data?.count,
//     data?.data?.total,
//     data?.data?.count,
//     data?.data?.shipments?.length,
//     data?.data?.products?.length,
//     data?.data?.users?.length,
//     data?.data?.brands?.length,
//     data?.data?.length,
//     data?.shipments?.length,
//     data?.products?.length,
//     data?.users?.length,
//     data?.brands?.length,
//     data?.items?.length,
//     data?.results?.length,
//     Array.isArray(data) ? data.length : null,
//   ];

//   for (const val of candidates) {
//     if (typeof val === "number" && val >= 0) return val;
//   }
//   return 0;
// };

// // ─── Animated number ──────────────────────────────────────────────────────────
// const AnimatedNumber = ({ value }) => {
//   const [display, setDisplay] = useState(0);
//   const prevRef = useRef(0);

//   useEffect(() => {
//     const start = prevRef.current;
//     const end   = value;
//     if (start === end) return;

//     const duration  = 900;
//     const steps     = 45;
//     const increment = (end - start) / steps;
//     let current = start;
//     let step    = 0;

//     const timer = setInterval(() => {
//       step++;
//       current += increment;
//       if (step >= steps) {
//         setDisplay(end);
//         prevRef.current = end;
//         clearInterval(timer);
//       } else {
//         setDisplay(Math.round(current));
//       }
//     }, duration / steps);

//     return () => clearInterval(timer);
//   }, [value]);

//   return <span>{display.toLocaleString()}</span>;
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// const StatsSection = () => {
//   const [counts, setCounts]   = useState({ products: 0, users: 0, orders: 0, brands: 0 });
//   const [loading, setLoading] = useState(true);

//   const fetchData = async () => {
//     const [productsResult, usersResult, ordersResult, brandsResult] =
//       await Promise.allSettled([

//         fetch(PRODUCTS_API).then((r) => {
//           if (!r.ok) throw new Error(`Products ${r.status}`);
//           return r.json();
//         }),

//         fetch(USERS_API).then((r) => {
//           if (!r.ok) throw new Error(`Users ${r.status}`);
//           return r.json();
//         }),

//         fetch(ORDERS_DELIVERED_API, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             // "Authorization": "Bearer TUMHARA_TOKEN_YAHAN",
//           },
//           credentials: "include",
//         }).then((r) => {
//           if (!r.ok) throw new Error(`Orders ${r.status}`);
//           return r.json();
//         }),

//         fetch(BRANDS_API).then((r) => {
//           if (!r.ok) throw new Error(`Brands ${r.status}`);
//           return r.json();
//         }),
//       ]);

//     // ── DEBUG ──
//     console.log("📦 PRODUCTS:", productsResult.status === "fulfilled"
//       ? productsResult.value : productsResult.reason);
//     console.log("👤 USERS:", usersResult.status === "fulfilled"
//       ? usersResult.value : usersResult.reason);
//     console.log("🚚 DELIVERED ORDERS:", ordersResult.status === "fulfilled"
//       ? ordersResult.value : ordersResult.reason);
//     console.log("🏷️ BRANDS:", brandsResult.status === "fulfilled"
//       ? brandsResult.value : brandsResult.reason);

//     let deliveredCount = 0;
//     if (ordersResult.status === "fulfilled") {
//       const d = ordersResult.value;
//       deliveredCount =
//         d?.data?.total ??
//         d?.data?.count ??
//         d?.total ??
//         d?.count ??
//         d?.data?.shipments?.length ??
//         extractCount(d);
//     }

//     setCounts({
//       products: productsResult.status === "fulfilled"
//         ? extractCount(productsResult.value) : counts.products,
//       users: usersResult.status === "fulfilled"
//         ? extractCount(usersResult.value) : counts.users,
//       orders: deliveredCount,
//       brands: brandsResult.status === "fulfilled"
//         ? extractCount(brandsResult.value) : counts.brands,
//     });

//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchData();
//     const interval = setInterval(fetchData, 30000);
//     return () => clearInterval(interval);
//   }, []);

//   const stats = [
//     { icon: "👤", label: "Happy Users",      value: counts.users,    color: "#ef4444" },
//     { icon: "📦", label: "Orders Delivered", value: counts.orders,   color: "#f97316" },
//     { icon: "🛒", label: "Products",         value: counts.products, color: "#ef4444" },
//     { icon: "🏷️", label: "Brands",           value: counts.brands,   color: "#8b5cf6" },
//   ];

//   return (
//     <div
//       style={{
//         background: "linear-gradient(135deg, #fff5f5 0%, #fff 50%, #fff5f5 100%)",
//         borderTop: "2px solid #fee2e2",
//         borderBottom: "2px solid #fee2e2",
//         padding: "14px 16px",
//       }}
//     >
//       <div
//         style={{
//           maxWidth: "1100px",
//           margin: "0 auto",
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: "8px 32px",
//         }}
//       >
//         {loading
//           ? [1, 2, 3, 4].map((i) => (
//               <div key={i} style={{ padding: "6px 16px" }}>
//                 <div
//                   style={{
//                     width: "90px",
//                     height: "18px",
//                     borderRadius: "4px",
//                     background:
//                       "linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)",
//                     backgroundSize: "200% 100%",
//                     animation: "shimmer 1.2s infinite",
//                   }}
//                 />
//               </div>
//             ))
//           : stats.map((stat, index) => (
//               <React.Fragment key={stat.label}>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                     fontSize: "14px",
//                     fontWeight: "500",
//                     color: "#374151",
//                     padding: "6px 0",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   <span style={{ fontSize: "18px" }}>{stat.icon}</span>
//                   <span
//                     style={{
//                       color: stat.color,
//                       fontWeight: "700",
//                       fontSize: "15px",
//                       fontVariantNumeric: "tabular-nums",
//                     }}
//                   >
//                     <AnimatedNumber value={stat.value} />+
//                   </span>
//                   <span style={{ color: "#6b7280" }}>{stat.label}</span>
//                 </div>

//                 {index < stats.length - 1 && (
//                   <div
//                     style={{
//                       width: "1px",
//                       height: "20px",
//                       background: "#fca5a5",
//                       flexShrink: 0,
//                     }}
//                   />
//                 )}
//               </React.Fragment>
//             ))}
//       </div>

//       <style>{`
//         @keyframes shimmer {
//           0%   { background-position: -200% 0; }
//           100% { background-position:  200% 0; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default StatsSection;


import React, { useEffect, useState, useRef } from "react";

const PRODUCTS_API = "https://server.havbit.in/api/public/products";
const BRANDS_API   = "https://server.havbit.in/api/vendor/brands/public";

// ─── Smart count extractor ────────────────────────────────────────────────────
const extractCount = (data) => {
  if (!data) return 0;
  if (typeof data === "number") return data;

  const candidates = [
    data?.total,
    data?.totalCount,
    data?.count,
    data?.data?.total,
    data?.data?.count,
    data?.data?.products?.length,
    data?.data?.brands?.length,
    data?.data?.length,
    data?.products?.length,
    data?.brands?.length,
    data?.items?.length,
    data?.results?.length,
    Array.isArray(data) ? data.length : null,
  ];

  for (const val of candidates) {
    if (typeof val === "number" && val >= 0) return val;
  }
  return 0;
};

// ─── Animated number ──────────────────────────────────────────────────────────
const AnimatedNumber = ({ value }) => {
  const [display, setDisplay] = useState(0);
  const prevRef = useRef(0);

  useEffect(() => {
    const start = prevRef.current;
    const end   = value;
    if (start === end) return;

    const duration  = 900;
    const steps     = 45;
    const increment = (end - start) / steps;
    let current = start;
    let step    = 0;

    const timer = setInterval(() => {
      step++;
      current += increment;
      if (step >= steps) {
        setDisplay(end);
        prevRef.current = end;
        clearInterval(timer);
      } else {
        setDisplay(Math.round(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [value]);

  return <span>{display.toLocaleString()}</span>;
};

// ─── Main Component ───────────────────────────────────────────────────────────
const StatsSection = () => {
  const [counts, setCounts]   = useState({ products: 0, brands: 0 });
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const [productsResult, brandsResult] =
      await Promise.allSettled([

        fetch(PRODUCTS_API).then((r) => {
          if (!r.ok) throw new Error(`Products ${r.status}`);
          return r.json();
        }),

        fetch(BRANDS_API).then((r) => {
          if (!r.ok) throw new Error(`Brands ${r.status}`);
          return r.json();
        }),
      ]);


    setCounts({
      products: productsResult.status === "fulfilled"
        ? extractCount(productsResult.value) : counts.products,
      brands: brandsResult.status === "fulfilled"
        ? extractCount(brandsResult.value) : counts.brands,
    });

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  const stats = [
    { icon: "📍", label: "Pincodes",  value: 19300,         color: "#ef4444" },
    { icon: "📦", label: "Products",  value: counts.products, color: "#f97316" },
    { icon: "🏷️", label: "Brands",    value: counts.brands,   color: "#8b5cf6" },
  ];

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #fff5f5 0%, #fff 50%, #fff5f5 100%)",
        borderTop: "2px solid #fee2e2",
        borderBottom: "2px solid #fee2e2",
        padding: "14px 16px",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px 32px",
        }}
      >
        {loading
          ? [1, 2, 3].map((i) => (
              <div key={i} style={{ padding: "6px 16px" }}>
                <div
                  style={{
                    width: "90px",
                    height: "18px",
                    borderRadius: "4px",
                    background:
                      "linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)",
                    backgroundSize: "200% 100%",
                    animation: "shimmer 1.2s infinite",
                  }}
                />
              </div>
            ))
          : stats.map((stat, index) => (
              <React.Fragment key={stat.label}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#374151",
                    padding: "6px 0",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span style={{ fontSize: "18px" }}>{stat.icon}</span>
                  <span
                    style={{
                      color: stat.color,
                      fontWeight: "700",
                      fontSize: "15px",
                      fontVariantNumeric: "tabular-nums",
                    }}
                  >
                    <AnimatedNumber value={stat.value} />+
                  </span>
                  <span style={{ color: "#6b7280" }}>{stat.label}</span>
                </div>

                {index < stats.length - 1 && (
                  <div
                    style={{
                      width: "1px",
                      height: "20px",
                      background: "#fca5a5",
                      flexShrink: 0,
                    }}
                  />
                )}
              </React.Fragment>
            ))}
      </div>

      <style>{`
        @keyframes shimmer {
          0%   { background-position: -200% 0; }
          100% { background-position:  200% 0; }
        }
      `}</style>
    </div>
  );
};

export default StatsSection;